import NavigationSection from "../../../core/model2/navigation/navigation-section";
import {NavigationButtonTypeClass, PersonalViewsWithMainMenu} from "../@const";

export default function getNavigationButtonTypeClass (section: NavigationSection) {

    if (!!section?.space && !!section.menuComponent) {
        return NavigationButtonTypeClass.IS_TAB
    }

    if (!!section.menuComponent && section.personalView?.type && PersonalViewsWithMainMenu.includes(section.personalView.type)) {
        return NavigationButtonTypeClass.IS_TAB
    }

    return NavigationButtonTypeClass.IS_BUTTON

}
